import { CAST_AI } from '@cast/constants';
import {
  Divider,
  ExternalLink,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';
import { getDocsLink } from '@cast/utils';

import { FeatureComparisonCard } from './FeatureComparisonCard';
import {
  FreeFeaturesList,
  PaidFeaturesList,
  TrialFeaturesList,
} from '../TrialFeatures';

export const TrialFeaturesComparison = () => {
  return (
    <Stack direction="row" gap="24px">
      <FeatureComparisonCard title="Free version">
        <Stack gap="16px">
          <FreeFeaturesList />

          <Divider />

          <PaidFeaturesList />
        </Stack>
      </FeatureComparisonCard>

      <FeatureComparisonCard title="30-day free trial">
        <Stack gap="16px">
          <TrialFeaturesList />

          <Typography variant="P12M" color={tokens.theme.fg.structural.primary}>
            Start using {CAST_AI} right away with zero financial commitment or
            future obligations.{' '}
            <ExternalLink link={getDocsLink('docs_trial')}>
              Learn more
            </ExternalLink>
          </Typography>
        </Stack>
      </FeatureComparisonCard>
    </Stack>
  );
};
